// components/MainView/EntityFieldLevelCitationFlow/selectors.ts
import { createSelector } from 'reselect';
import type { State } from '../../../../state';

// 就绪位：把 6 个 flag 合并（用 !! 避免 undefined）
export const selectReady = createSelector(
  (s: State) => !!s.uiReducer?.isShowHistoricalFlow,
  (s: State) => !!s.uiReducer?.isShowPredictionFlow,
  (s: State) => !!s.dataReducer?.isDrawGrantTypeNodeFinished,
  (s: State) => !!s.dataReducer?.isEntityTypeGraphFinished,
  (s: State) => !!s.uiReducer?.isInitializeBubbleTreemapFinished,
  (s: State) => !!s.uiReducer?.isOptimizedBubbleTreemapFinished,
  (H, P, g, et, init, opt) => ((H || P) && g && et && init && opt)
);

// 图形输入：命中缓存时返回相同引用
export const selectGraphInputs = createSelector(
  (s: State) => s.dataReducer?.leafNodePosition_BubbleCenter?.leafNodePositionList ?? [],
  (s: State) => s.dataReducer?.leafNodePosition_BubbleCenter?.bubbleTreemapEntityTypeCenterXYList ?? [],
  (s: State) => s.dataReducer?.entityFieldGraph_InputData ?? [],
  (s: State) => s.dataReducer?.grantNodePositionList ?? [],
  (leaf, centers, fieldData, grants) => ({ leaf, centers, fieldData, grants })
);
